<div class="huddle-spotlight-top-panel">
  <div class="huddle-spotlight-control-panel">
    <div class="huddle-spotlight-left-control">
      <p class="tab-description">
          Recognize all spotlight entries with Smile Champions, customer testimonials, success stories, and branch details.
        </p>
    </div>
    <div class="huddle-spotlight-right-control">
      <!-- <app-search [data]="originalSpotlightData" (filteredData)="onFilteredData($event)"></app-search> -->
      <!-- Search Dropdown -->
      <div class="litmus-spotlight-filter-dd" #litmusfeedsearch id="litmusfeedsearch">
        <div class="litmus-spotlight-filter-dd-input" [class.active]="searchFieldConfig.showSearchList">
          <img class="search-icon" src="assets/images/magnify.svg">
          <input type="text" autocomplete="off" id="spotlightsearchfield" (keyup)="searchByField($event)" [(ngModel)]="searchFieldConfig.term" (click)="toggleSearchList()"
            [placeholder]="spotlightSearch.placeholder" />
          <button *ngIf="clearField.isEnabled" class="clear-button"
            (click)="getSpotlightsforSelectedFields(clearField)">
            <img class="clear-img" src="assets/images/close.svg">
          </button>
          <button (click)="focusSearchFilter()" class="field-dropdown-button" [class.active]="searchFieldConfig.showSearchList">
            <img src="assets/images/menu-down-dark.svg" />
          </button>
        </div>
        <ul id="litmus-search-selector" *ngIf="searchFieldConfig.isLoading" class="litmus-spotlight-filter-dd-list">
          <li class="loader">
            <span class="circle-loader"></span> Just a moment.
          </li>
        </ul>
        <ul id="litmus-search-list" *ngIf="searchFieldConfig.showSearchList && !searchFieldConfig.isLoading" class="litmus-spotlight-filter-dd-list">
          <li *ngFor="let item of searchResult.options" [class.disabled-message]="item.isError"
            (click)="getSpotlightsforSelectedFields(item)">
            {{item.displayText || item.text}}
          </li>
        </ul>
      </div>
      <!-- Search Dropdown -->
      <div class="widget-container">
      <div class="download-button" (click)="spotlightResponseDownload()">
        <span ><img class="opacity" src="assets/images/download.svg"></span>
      </div>
     <!-- <div class="divider"></div>
      <div class="fullscreen-button" (click)="toggleFullScreen()" >
        <span ><img src="assets/images/fullscreen-exit.svg"></span>
      </div> -->
    </div>
      <div class="litmus-spotlight-paging">
        <button [disabled]="!pagingButtons.isFirst || !isDataLoaded" (click)="paginateFeedList('first')">
          <img src="assets/images/chevron-double-left.svg" />
        </button>
        <button [disabled]="!pagingButtons.isPrevious || !isDataLoaded" (click)="paginateFeedList('previous')">
          <img src="assets/images/chevron-left.svg" />
        </button>
        <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}}
          of {{pagingDetails.total}} </span>
        <button [disabled]="!pagingButtons.isNext || !isDataLoaded" (click)="paginateFeedList('next')">
          <img src="assets/images/chevron-right.svg" />
        </button>
        <button [disabled]="!pagingButtons.isLast || !isDataLoaded" (click)="paginateFeedList('last')">
          <img src="assets/images/chevron-double-right.svg" />
        </button>
      </div>
    </div>
  </div>
</div>
<div class="table-holder" *ngIf="!isLoading">
  <!-- <app-ltms-data-table-v2 [data]="spotlightData" [columns]="columns"></app-ltms-data-table-v2> -->
  <app-overview-table *ngIf=" spotlightTable.rows.length" [type]="'accordion'" [config]="tableConfigs" [columns]="spotlightTable.header"
    [rows]="spotlightTable.rows" (onDataSort)="getSortedData($event)"></app-overview-table>
    <app-ltms-error *ngIf="!spotlightTable.rows.length" [code]="'404'"></app-ltms-error>


</div>
<div *ngIf="isLoading">
  <div class="d-flex align-items-center justify-content-center" style="min-height: 15rem">
    <div role="status">
      <app-ltms-loader></app-ltms-loader>
    </div>
  </div>
</div>